import styled from 'styled-components';

export const FormationContainer = styled.div`
     height: 800px; 
     padding: 150px 0px 1100px 0px; 
`;

export const FormationH1 = styled.h1`
    text-align: center; 
    margin: 0px 0px 50px 0px; 
    font-size: 2.5rem; 
`;

export const FormationH3 = styled.h3`
`;

export const FormationH5 = styled.h5`
    
`;

export const FormationP = styled.p`
     
`;

export const BtnWrap = styled.div`
    display: flex; 
    justify-content: flex-start; 
    margin: 16px 0px 0px 0px; 
`;


